import { useAppContentStore } from '@/stores/appContent'
import { useCartStore } from '@/stores/cart'
import { useCartConfigurationStore } from '@/stores/cartConfiguration'
import { useCatalogStore } from '@/stores/catalog'
import { useCatalogContentStore } from '@/stores/catalogContent'
import { useMainStore } from '@/stores/main'
import { usePackageBuilderStore } from '@/stores/packageBuilder'

export function resetStores(resetAppContent: boolean = false) {
  const cartStore = useCartStore()
  const catalogStore = useCatalogStore()
  const catalogContentStore = useCatalogContentStore()
  const cartConfigurationStore = useCartConfigurationStore()
  const mainStore = useMainStore()
  const packageBuilderStore = usePackageBuilderStore()

  cartStore.resetStore()
  catalogStore.resetStore()
  catalogContentStore.resetStore()
  cartConfigurationStore.resetStore()
  mainStore.resetStore()
  packageBuilderStore.resetStore()

  if (resetAppContent) {
    const appContentStore = useAppContentStore()
    appContentStore.resetStore()
  }
}
